/************************************
MODULE:         Functionality fallbacks
WHAT IT DOES:   Add fallbacks for old browsers in case some functionality isn't supported (like flex) 
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {

    function initOldBrowsers() {
        if($('html').hasClass('no-flexbox')) {
            fixFlex();
            $(window).on('resize:finished', fixFlex);
        }
    }

    function fixFlex() {
        var gridFlex = $('.grid_flex:not(.grid_flex-column)'),
            children = gridFlex.children();

        children.css('height', '');
        $('.grid__item_flex').css('height', '');

        if (window.App.globals.isMobileSmall)
            return;

        for (var i = 0, l = gridFlex.length; i < l; i++) {
            fixFlexSingle(gridFlex.eq(i));
        }
    }

    function fixFlexSingle(grid) {
        var children = grid.children(),
            flexChildren = children.filter('.grid__item_flex').children(),
            maxHeight = 0;

        for (var i = 0, l = children.length; i < l; i++) {
            maxHeight = Math.max(maxHeight, children.eq(i).outerHeight());
        }

        children.css('height', maxHeight);
        flexChildren.css('height', maxHeight - parseInt(flexChildren.first().css('margin-bottom')) - parseInt(flexChildren.first().css('margin-top')));
    }

    return {
        init: initOldBrowsers
    };

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.oldbrowsers.js
 ** module id = 49
 ** module chunks = 24
 **/